export const colors = {
  primary: '#001C38', // Enterprise Midnight
  primaryLight: '#D3E4FF', // Light blue info containers
  primaryDark: '#001021',
  secondary: '#38BDF8', // Neon Sky Blue
  accent: '#2E6C45', // Tech Progress Emerald
  
  // Surfaces & Backgrounds
  background: '#FDFBFF', // Clean bento off-white canvas
  backgroundDark: '#090D16', // Jet midnight space black for dark mode
  surface: '#FFFFFF', // Clean bento rounded white card base
  surfaceDark: '#101726', // Deep bento dark mode surface
  surfaceMuted: '#F1F0F4', // Grey panels
  border: '#C3C7CF', // Bento border contours
  borderDark: '#2E3B52', // Dark mode borders

  // States & Indicators
  success: '#E2F3E7', // Soft green bg
  successText: '#0A2012',
  successBorder: '#2E6C45',
  warning: '#FFF1E0', // Soft gold warning
  warningText: '#8F5C00',
  error: '#FFFFDAD6', // Crimson alert warning background
  errorText: '#BA1A1A', // High contrast error crimson
  info: '#E0F2FE', // Soft sky blue bg
  infoText: '#0369A1',

  // Typography
  textPrimary: '#1A1C1E', // Strong dark charcoal text
  textSecondary: '#43474E', // Medium charcoal text
  textMuted: '#707784', // Disabled helper text
  textOnPrimary: '#FFFFFF',
  textOnPrimaryDark: '#F1F5F9'
};

export default colors;
